import React from "react";
import { defaultDropList } from "../Data/WBComponentDefaults";
import { WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import LayoutNode, { getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import CreateAttributeList, { componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { GetLocationHoverAtt, GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";
import { GenericBusinessControl } from "vagaro-website-rendering/src/components/Binding/GenericBusinessControl";
import WebDesigner from "../WebDesigner";


export default class BusinessDescription extends WBComponent {
    constructor() {
        super();
        this.vagaroLink = "https://www.vagaro.com/business/businessprofile";
        this.typename = wBComponentTypeNames.businessDescription;
        this.displayName = "Description";
        this.dropList = defaultDropList;
        this.editList = [componentAttributeTypes.multiLocation, ...CreateAttributeList(true, true, true, true, false,false,false)];
        this.primaryEditAttributes = [componentAttributeTypes.multiLocation];
        this.contentEditable = false;
        this.icon = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor"><path d="M88 0c13.3 0 24 10.7 24 24V64l376 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-376 0V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V112H24C10.7 112 0 101.3 0 88S10.7 64 24 64H64V24C64 10.7 74.7 0 88 0zM192 336H432V192H192V336zM144 176c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H176c-17.7 0-32-14.3-32-32V176z" /></svg>
    }

    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        setNodeComponentAttributeValue(thisLayout, componentAttributeTypes.multiLocation, manager.props.siteData.userContext.businessId);
    }

    RenderLayout({ component, screenSize, userContext, isEditor }: WBRenderProps) {
        const bid = getNodeComponentAttributeValue(component, componentAttributeTypes.multiLocation, userContext.businessId);
        const atts = GetNodeDomAttributes("max-100 vp-2 vb-control relative", component, screenSize, isEditor);
        if (!isEditor) {

            return <BusinessPlaceHolder node={component} dataKey="description" layout={'1'} classNames={atts.className} >
                {/* <GenericBusinessControl key={component.id + bid} dataKey={"description"} node={component} userContext={userContext} bLocationId={bid} layout="1" forceStencil={true} /> */}
             
                </BusinessPlaceHolder>
        }

        return (
            <div {...atts} {...GetLocationHoverAtt(component,userContext)}>
                <GenericBusinessControl key={component.id + bid} dataKey={"description"} node={component} userContext={userContext} bLocationId={bid} layout="1" />

            </div>
        )

    }

}






